import React from "react";
import "./CompareTable.css";
import { useNavigate } from "react-router-dom";

const CompareTable = ({ compareItems, onDelete }) => {

  const navigate = useNavigate();
  return (
    <div className="table-container">
      <table className="compare-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Price</th>
            <th>Description</th>
            <th>SKU</th>
            <th>Availability</th>
            <th>Weight</th>
            <th>Dimensions</th>
            <th>Brand Name</th>
            <th>Rating</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {compareItems && compareItems.length > 0 ? (
            compareItems.map((product, index) => (
              <tr key={index}>
                <td>
                  <img
                    src={product.image || "https://via.placeholder.com/80"}
                    alt={product.name || "Product"}
                    className="product-image"
                  />
                  <p onClick={() => navigate(`/product/${product.model.split('/')[0]}`)} style={{cursor:'pointer'}}>{product.name || "N/A"}</p>
                </td>
                <td>
                  ₹{product.sale_price || product.regular_price || "N/A"}
                </td>
                <td>{<ul dangerouslySetInnerHTML={{ __html: product.description }}></ul> || "N/A"}</td>
                <td>{product.sku || "N/A"}</td>
                <td>{product.stock ? "In Stock" : "Out of Stock"}</td>
                <td>{product.weight || "N/A"}</td>
                <td>{product.dimmensions || "N/A"}</td>
                <td>{product.brand || "N/A"}</td>
                <td>{product.rating || "N/A"}</td>
                <td>
                  <button
                    className="delete-button"
                    onClick={() => onDelete(product)}
                  >
                    X
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={10} className="no-data">
                No products to compare.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CompareTable;
